import React from 'react';

import './index.css';
import { $Bsy, BsyUtils } from '../../../utils/Utils';
import { BsyConfig } from '../../../global/BsyConfig';

import BsyDashBase from '../BsyDashBase';
import Gantt from './gantt';
import BsyProgressBar from '../../BsyProgressBar';
import BsySLoading from '../../BsySLoading';
import BsyMaskLayer from '../../BsyMaskLayer';
import BsyFormPane from '../../BsyFormPane';
import BsyAlert from '../../BsyAlert';
import { dayjsUtils } from '../../../utils/dayjsUtils';
import { getAfterSuffix } from '../../../utils/getAfterSuffix';

export default class BsyGantt extends BsyDashBase {

  static defaultProps = {
    url: '/data/report_gantt_list',
    asyncExportURL: "/data/combined_group/excel_export",
    forms: [],
    dashTitle: '',
    title: '',
    chartType: 'gantt',
    defaultSort: [],
    zoomLevel: "auto",
    fields: [],
    data: [],
    // zoomLevel: 5,
    legend: {
      enable: true,
      position: "bottom"
    },
    autoLoad: true,
    mountAutoLoad: true,
  }

  constructor(props) {
    super(props);
    this.zoomLevel = this._initzoomLevel(props);
    this.state = {
      columns: props.columns,
      url: props.url,
      sort: props.defaultSort,
      widgetId: props.widgetId,
      appId: props.appId,
      entryId: props.entryId,
      forms: props.forms,
      xFields: props.xFields,
      dashTitle: props.dashTitle,
      title: props.title,
      isLoading: false,
      data: props.data,
      classUUID: 'BsyGantt_' + new Date().getTime(),
      zoomLevel: this.zoomLevel,
      level: BsyConfig().CONST.GanttMode.length - 1,
      modeText: BsyUtils.getGanttZoomlevelName(this.zoomLevel),
      popupFormPath: props.popupFormPath,
      autoLoad: props.autoLoad,
      dataEmpty: false,
    };
    this.popupFormPath = [...this.props.popupFormPath];
    this.ref = React.createRef();
    this.rootRef = React.createRef();

    this.datamaps = {};
    this.legend_datas = [];
    this.filterParam = null;
    this.elWidth = 0;
    this.isDashFull = props.isDashFull;
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

    if (nextProps.isDashFull !== this.isDashFull) {
      this.isDashFull = nextProps.isDashFull;
    }
  }

  _initzoomLevel = (opt) => {

    let zoomLevel = 5;
    if (opt.zoomLevel == "auto") {
      if (opt.ganttFields) {
        // console.log('------------- 1 -----------')
        if (
          (opt.ganttFields.start && opt.ganttFields.start.date_precision === "day") ||
          (opt.ganttFields.end && opt.ganttFields.end.date_precision === "day")) {
          zoomLevel = 4;
          // console.log('------------- 2 --- month --------')
        } else if (
          (opt.ganttFields.start && opt.ganttFields.start.date_precision === "month") ||
          (opt.ganttFields.end && opt.ganttFields.end.date_precision === "month")
        ) {
          // console.log('------------- 3 -----------')
          zoomLevel = 2;
        }
      }
    }
    else {
      if (!isNaN(parseInt(opt.zoomLevel))) {
        zoomLevel = opt.zoomLevel - 1;
      }
    }
    // console.log(zoomLevel)
    return zoomLevel;
  }

  _getInfoSizeMap = () => {
    let t = this._getInfoSizeMapKey();
    return BsyUtils.Store.get(t) || null;
  }

  _updateInfoSize = (n) => {
    let a = this._getInfoSizeMapKey()
    BsyUtils.Store.set(a, n)
  }

  _getInfoSizeMapKey = () => {
    let t = this.props;
    return BsyUtils.Store.getKey("ganttInfoSizeMap", {
      appId: t.appId,
      entryId: t.entryId,
      widgetId: t.widgetId,
    })
  }

  //获取同一行的数据
  getRowDatas = (dataid) => {
    let datas = null;
    BsyUtils.forEach(this.tasks, function (a1, b1) {
      if (b1.id === dataid) {
        datas = b1;
        return !1;
      }
      if (b1.hasOwnProperty('datas')) {
        BsyUtils.forEach(b1.datas, function (a2, b2) {
          if (b2.id === dataid) {
            datas = b1;
            return !1;
          }
        })
      }
      if (!BsyUtils.isObjectEmpty(datas)) {
        return !1;
      }
    })
    let dataMap = {};
    if (datas) {
      dataMap['task_' + datas._id] = datas;
      if (datas.hasOwnProperty('datas')) {
        BsyUtils.forEach(datas.datas, function (a2, b2) {
          dataMap['task_' + b2._id] = b2
        })
      }
    }
    return dataMap;
  }
  //根据开始结束时间 判断区域
  overlapping = (dataMap, dataid) => {
    let currentData = dataMap[dataid];
    let result = [];
    result.push(currentData)
    BsyUtils.forEach(dataMap, function (a1, b1) {
      if (b1._id != currentData._id) {
        if (currentData.start < b1.start && currentData.end > b1.start) {
          result.push(b1);
        } else if (currentData.start < b1.end && currentData.end > b1.end) {
          result.push(b1);
        } else if (b1.start < currentData.start && b1.end > currentData.start) {
          result.push(b1);
        } else if (b1.start < currentData.end && b1.end > currentData.end) {
          result.push(b1);
        }
      }
    })
    return result
  }

  taskTip = (dataid) => {
    
    const { mode } = this.state;
    if( mode === "preview" ) {
        return;
    }
    
    let that = this;

    if (BsyUtils.isObjectEmpty(this.props.fields)) {
      return;
    }

    //根据dataid 同一行单
    let datas = this.getRowDatas(dataid);
    if (BsyUtils.isObjectEmpty(datas))
      return "";
    datas = this.overlapping(datas, dataid);

    that._doShowData(0, datas);
  }

  _doShowData = (e, datas, v, w) => {
    let i = datas[e]
    // this._dataIndex = e; c
    let extDashData = {
      appId: this.props.appId,
      entryId: this.props.entryId,
      formId: this.props.forms[0],
      widgetId: this.props.widgetId,
    }
    let that = this;
    if (i) {
      let a = this,
        n = this.props,
        s = i._id,
        o = this.header;
      // this._switchCurrentRow(e);
      let r = window.$('<div class="x-window-mask modal light"/>').css({
        "z-index": window.FX.STATIC.zIndex++
      });
      let f = i._id
      let b = e;
      let hasCopy =  i.dataPerms ? i.dataPerms.copy : false;
      let hasEditBtn = i.dataPerms ? i.dataPerms.update : n.itemEditable,
        hasDeleteBtn = i.dataPerms ? i.dataPerms.delete : n.itemRemovable,
        hasLog = i.dataPerms ? i.dataPerms.log : n.itemLog,
        hasComment = i.dataPerms ? i.dataPerms.comment : n.itemComment,
        flow_log = i.dataPerms ? i.dataPerms.flow_log : n.flow_log;


      if (a.reftype == 'etl_table' || a.reftype == 'aggregate_table' || n.background == 1) {
        let config = {
          appId: n.appId,
          entryId: n.entryId,
          formId: n.forms[0],
          origin: "report",
          originPrint: "report",
          widgetId: n.widgetName,
          hasFlowLog: flow_log,
          hasLogView: flow_log,
          hasFlowBtn: flow_log,
          ptlist: [],
          hasShareBtn: !1,
          width: 1080,
          forms: n.forms,
          header: n.fields,
          data: i,
          multiTabs: null,
          dataId: i._id,
          optAuth: i.optAuth,
          title: n.title,
          height: "100%",
          hasSwitchBtn: !0,
          dataIndex: e + 1,
          hasPrintBtn: !0,
          hasCustomPrint: !0,
          dataCount: datas.length,
          hasEditBtn: hasEditBtn,
          hasDeleteBtn: hasDeleteBtn,
          dataPerms: i.dataPerms,
          hasLog: n.isEtlTable ? false : hasLog,
          hasComment: n.isEtlTable ? false : hasComment,
          onSwitchData: function (a, b) {
            let c = e.data[a - 1];
            return c;
          },

        }

        let layerRef = null;
        BsyMaskLayer({
          customCls: 'fadein-right',
          onMaskClick: (event) => {
            // if (event.target.classList.contains("fadein-right")) {
            //   layerRef.close();
            // }
          },
          onContentCreate: (ref) => {
            layerRef = ref;

            return <BsyFormPane
              {...config}
              mode={'view'}
              entrance={"report"}
              onClose={status => {
                layerRef && layerRef.close();

              }}
            />

          }
        })

        return;
      }


      let newFieldMap = {};
      let newFields = [];
      BsyUtils.forEach(n.fields, function (f1, h1) {
        let xx = {}
        if (h1.subform) {
          if (newFields.indexOf(h1.subform) == -1)
            newFields.push(h1.subform)

          if (!newFieldMap[h1.subform]) {
            newFieldMap[h1.subform] = {
              form: n.forms[0],
              type: 'subform',
              name: h1.subform,
              items: [],
              subform_create: true,
              subform_insert: true,
              subform_delete: true,
              subform_edit: true,
              subform_import: !0,
              subform_dataload: !0,
              isEditable: true,
              title: h1.title.split('.')[0],
              text: h1.title.split('.')[0],
            }
          }
          let dd = window.$.extend({}, h1);
          dd.name = dd.name.split('.')[1];
          dd.title = dd.title.split('.')[1];
          newFieldMap[dd.subform].items.push(dd)
        } else {
          newFieldMap[h1.name] = window.$.extend({}, h1)
          newFieldMap[h1.name].isEditable = true;
          newFields.push(h1.name)
        }
      })

      let fd = [];
      BsyUtils.forEach(newFields, function (a1, b1) {
        fd.push(newFieldMap[b1]);
      })

      let d1 = BsyUtils.checkRefApp({
        appId: n.appId,
        entryId: n.entryId,
        formId: n.forms[0],
        dataId: f,
        iseditable: !1,
        fields: fd, //n.fields,
        formulas: n.formulas,
        popupFormPath: a.popupFormPath.concat({
          appId: a.props.appId,
          entryId: a.props.entryId,
          formId: a.props.forms[0],
          widgetId: a.props.widgetId,
        }),
      });

      let t11;
      BsyMaskLayer({
        customCls: 'sloading',
        onContentCreate: (ref) => {
          t11 = ref;
          return <div ><BsySLoading /> </div>
        }
      })
      const { restore } = BsyUtils.globalIdManager(d1.appId, d1.entryId);
      if (this.props.widgetId) {
        d1 = { ...d1, widgetId: this.props.widgetId };
      }
      window.FX.Utils.dataAjax({
        // url: "/data/read",
        url: "/data/read",
        data: d1
      }, function (g) {

        let fieldtabs = {};
        BsyUtils.forEach(g.form.items, function (a1, b1) {
          if (b1.tab)
            fieldtabs[b1.widget.widgetName] = b1.tab;
          if (b1.widget.colorEnable) {
            BsyUtils.forEach(fd, function (a2, b2) {
              if (b2.name == b1.widget.widgetName) {
                fd[a2].colorEnable = b1.widget.colorEnable;
              }
            })
          }
          if (newFieldMap[b1.widget.widgetName] && newFieldMap[b1.widget.widgetName].type == 'subform') {
            BsyUtils.forEach(fd, function (a2, b2) {
              if (b2.name == b1.widget.widgetName) {
                fd[a2].text = b1.label;
                fd[a2].title = b1.label;
              }
              b1.mobileStyle = b1.widget.mobileStyle;
              BsyUtils.forEach(b1.widget.items, function (subindex, subdata) {
                if (subdata.widget.colorEnable) {
                  BsyUtils.forEach(fd[a2].items, function (fdsubindex, fdsubdata) {
                    if (fdsubdata.name == subdata.widget.widgetName) {
                      fd[a2].items[fdsubindex].colorEnable = subdata.widget.colorEnable;
                    }
                  })
                }
              })
            })
          }
        })
        let newdata = {};
        let fields = [];
        let o1 = a._parseFieldLabelFormat(fd, g.form.items);
        BsyUtils.forEach(o1, function (a1, b1) {
          let tmpdata = window.$.extend({}, b1);

          if (["dataload",'button'].indexOf(b1.type) > -1) {
            return !0;
          }

          if (fieldtabs.hasOwnProperty(b1.name)) {
            tmpdata.tab = fieldtabs[b1.name];
          }
          fields.push(tmpdata);
          newdata[b1.tag] = g.data[b1.name];
          newdata[b1.name] = g.data[b1.name];
        })
        newdata["_id"] = g.data["_id"];
        if (g.hasCoop || !g.hasFlow) {
          flow_log = !1;
        }
        if (flow_log) {
          newdata["flowStack"] = g.data["flowStack"];
          newdata["flowState"] = g.data["flowState"];
          newdata["chargers"] = g.data["chargers"];
          newdata["flowVer"] = g.data["flowVer"];
        }
        newdata = window.$.extend(newdata, g.data);
        if (n.readData) {
          //外链查询使用
          i.dataPerms.ptlist = n.ptlist;
        }
        let layerRef = null;
        let config = {
          appId: d1.appId,
          refAppId: d1.refAppId,
          entryId: d1.entryId,
          formId: d1.formId,
          is_dock_form: g.is_dock_form,
          form: g.form,
          hasCopy:hasCopy,
          rawdata: a.props.rawdata,
          extDashData: a.props.rawdata ? extDashData : null,
          // widgetId:a.props.widgetId,
          origin: "report",
          originPrint: "report",
          widgetId: n.widgetName || a.props.widgetId,
          items: g.form.items,
          fieldShowRules: g.form.fieldShowRules,
          subformFieldShowRules: g.form.subformFieldShowRules,
          hasFlowLog: flow_log,
          hasLogView: flow_log,
          hasFlowBtn: flow_log,
          ptlist: n.isEtlTable ? [] : i.dataPerms && i.dataPerms.ptlist,
          hasShareBtn: !1,
          width: 1080,
          forms: n.forms,
          header: o1,
          allShowFields: o1,
          data: newdata,
          multiTabs: g.formTabs,
          formTabsStyle: g.formTabsStyle || {},
          dataId: g.data._id,
          optAuth: i.optAuth,
          title: n.title,
          height: "100%",
          hasSwitchBtn: !0,
          dataIndex: e + 1,
          hasPrintBtn: !0,
          hasCustomPrint: !0,
          dataCount: datas.length,
          hasEditBtn: hasEditBtn,
          hasDeleteBtn: hasDeleteBtn,
          dataPerms: i.dataPerms,
          hasLog: n.isEtlTable ? false : hasLog,
          hasComment: n.isEtlTable ? false : hasComment,
          popupFormPath: a.popupFormPath.concat({
            appId: a.props.appId,
            entryId: a.props.entryId,
            formId: a.props.forms[0],
            widgetId: a.props.widgetId,
          }),
          onSwitchData: function (a, b) {
            let c = datas[a - 1];
            return c
          },
          onDeleteData: function () {
            BsyAlert({
              title: React.language("del.data.tip"),
              type: "error",
              text4Ok: React.language("ok"),
              text4Cancel: React.language("cancel"),
              OkType: "red",
              ok: function () {
                that.doDeleteData(f);
                restore();
                layerRef && layerRef.close();
              }
            })
          },
        }

        BsyMaskLayer({
          customCls: 'fadein-right',
          onMaskClick: (event) => {
            // if (event.target.classList.contains("fadein-right")) {
            //   layerRef.close();
            // }
          },
          onContentCreate: (ref) => {
            layerRef = ref;
            return <BsyFormPane
              {...config}
              mode={'view'}
              entrance={"report"}
              onClose={status => {
                restore();
                layerRef && layerRef.close();
                if (status) {
                  that.loadData()
                }
              }}
            />

          }
        })
      }, function () {
        restore();
        t11 && t11.close();
        return !1;
      }, function () {
        restore();
        t11 && t11.close();
      });
    }
  }
  doDeleteData = (a) => {
    let b = this.props,
      c = this;
    let t = b;
    let _this = this;
    let d = {
      appId: b.appId,
      entryId: b.entryId,
      formId: b.forms[0],
      idList: a,
      popupFormPath: _this.popupFormPath.concat({
        appId: _this.props.appId,
        entryId: _this.props.entryId,
        formId: _this.props.forms[0],
        widgetId: _this.props.widgetId,
      }),
    };
    if (BsyUtils.isObjectEmpty(a)) {
      window.FX.Msg.toast({
        type: "warning",
        msg: React.language("no.data.selected")
      })
      return;
    }

    d = BsyUtils.checkRefApp(d);
    window.FX.Utils.dataAjax({
      url: "/data/remove",
      data: d
    }, function (data) {
      c.reload(null, false, false, t.defaultSort);
    })
  }
  _doEditData = (b, c, datas, data, r) => {
    if (b) {
      r.find('.widget-wrapper').length && r.find('.widget-wrapper').hide();
      r.find('.log-wrapper').length && r.find('.log-wrapper').hide();
      let d = this.props,
        e = this,
        f = window.$('<div class="x-window-mask"/>').css({
          "z-index": window.FX.STATIC.zIndex++
        }).appendTo("body");
      let d1 = BsyUtils.checkRefApp({
        appId: d.appId,
        entryId: d.entryId,
        formId: d.forms[0],
        dataId: b,
        iseditable: true,
      });

      let i = datas[c];
      let n = d;

      let hasEditBtn = i.dataPerms ? i.dataPerms.update : n.itemEditable,
        hasDeleteBtn = i.dataPerms ? i.dataPerms.delete : n.itemRemovable,
        hasLog = i.dataPerms ? i.dataPerms.log : n.itemLog,
        hasComment = i.dataPerms ? i.dataPerms.comment : n.itemComment,
        flow_log = i.dataPerms ? i.dataPerms.flow_log : n.flow_log;

      let t11 = window.FX.Utils.createLoadLayer("body", {
        isLight: !1,
        hasLoader: !0
      });

      let newFieldMap = {};
      let newFields = [];
      BsyUtils.forEach(n.fields, function (f1, h1) {
        let xx = {}
        if (h1.subform) {
          if (newFields.indexOf(h1.subform) == -1)
            newFields.push(h1.subform)

          if (!newFieldMap[h1.subform]) {
            newFieldMap[h1.subform] = {
              form: n.forms[0],
              type: 'subform',
              name: h1.subform,
              items: [],
              subform_create: true,
              subform_insert: true,
              subform_delete: true,
              subform_edit: true,
              subform_import: !0,
              subform_dataload: !0,
              isEditable: true,
              title: h1.title.split('.')[0],
              text: h1.title.split('.')[0],
            }
          }
          let dd = window.$.extend({}, h1);
          dd.name = dd.name.split('.')[1];
          dd.title = dd.title.split('.')[1];
          newFieldMap[dd.subform].items.push(dd)
        } else {
          newFieldMap[h1.name] = window.$.extend({}, h1)
          newFieldMap[h1.name].isEditable = true;
          newFields.push(h1.name)
        }
      })

      let fd = [];
      BsyUtils.forEach(newFields, function (a1, b1) {
        fd.push(newFieldMap[b1]);
      })
      d1.popupFormPath = e.popupFormPath.concat({
        appId: e.props.appId,
        entryId: e.props.entryId,
        formId: e.props.forms[0],
        widgetId: e.props.widgetId,
      })
      if (this.props.widgetId) {
        d1 = { ...d1, widgetId: this.props.widgetId };
      }
      window.FX.Utils.dataAjax({
        url: "/data/read",
        data: d1
      }, function (g) {
        window.FX.STATIC.IS_EVENT = g.isEvent === true;
        //2022 12 17 查询原始数据改动 直接走后端权限，前端不需要重装判断了
        d.optAuth = { ...i.optAuth }
        //报表 可编辑权限根据报表设计走
        // BsyUtils.forEach(fd, function (index, field) {
        //   d.optAuth = d.optAuth || [];
        //   d.optAuth[field.name] = {
        //     enable: field.hasOwnProperty('isEditable') ? field.isEditable : true,
        //     visible: true
        //   };
        //   if (field.type == 'subform') {
        //     window.$.extend(d.optAuth[field.name], {
        //       subform_create: field.hasOwnProperty('subform_create') ? field.subform_create : true,
        //       subform_delete: field.hasOwnProperty('subform_delete') ? field.subform_delete : true,
        //       subform_edit: field.hasOwnProperty('subform_edit') ? field.subform_edit : true,
        //       subform_import: field.hasOwnProperty('subform_import') ? field.subform_import : true,
        //       subform_dataload: field.hasOwnProperty('subform_dataload') ? field.subform_dataload : true,
        //     });
        //     BsyUtils.forEach(field.items, function (ind, subfield) {
        //       d.optAuth[[field.name, subfield.name].join(".")] = {
        //         enable: subfield.hasOwnProperty('isEditable') ? subfield.isEditable : true,
        //         visible: true
        //       }
        //     })
        //   }
        // });
        //有权限组值才会走 判断
        d.authGroupId = 0;
        let optAuth = window.$.extend({}, d.optAuth)

        if (g.hasOwnProperty("optAuth")) {
          optAuth = window.$.extend({}, optAuth, g.optAuth)
        }

        if (g.hasCoop || !g.hasFlow) {
          flow_log = !1;
        }

        window.FX.STATIC.APPID = d1.appId;
        window.FX.STATIC.ENTRYID = d1.formId;

        new window.FX.Form(window.$.extend(g.form, {
          renderEl: window.$("<div class='x-shadow-content'/>").appendTo(f.addClass(" modal light")),
          appId: d1.appId,
          entryId: d1.formId,
          // formId: d1.formId,
          is_dock_form: g.is_dock_form,
          dataId: b,
          customCls: "more-btn",
          submitUrl: "/data/update",
          multiTabs: g.formTabs,
          formTabsStyle: g.formTabsStyle || {},
          submitData: {
            dataId: b
          },
          title: g.formName,
          width: 1080,
          hasFlow: !g.hasCoop && g.hasFlow,
          hasLogView: !g.hasCoop && g.hasFlow && g.hasLogView,
          hasLog: hasLog,
          hasFlowLog: flow_log,
          hasComment: hasComment,
          height: "100%",
          tabs: g.tabs,
          submitText: React.language("modify"),
          cancelText: React.language("cancel"),
          ignoreOptAuth: d.ignoreOptAuth,
          ignoreValidate: d.ignoreValidate,
          widgetOptAuth: optAuth, // d.optAuth || g.optAuth,
          authGroupId: 0,
          editValue: g.data,
          mode: "edit",
          // buttonPosition: "middle",
          popupFormPath: e.popupFormPath.concat({
            appId: e.props.appId,
            entryId: e.props.entryId,
            formId: e.props.forms[0],
            widgetId: e.props.widgetId,
          }),
          onSuccess: function (a) {
            f.find(".widget-wrapper").length && f.find(".widget-wrapper").remove();
            f.find(".log-wrapper").length && f.find(".log-wrapper").remove();
            f.find(".footer").length && f.find(".footer").remove();
            // f.remove();
            // r && r.remove();
            e.reload(null, null, null, d.defaultSort);
            // data = e._dataMerge(data,a.data);
            e._doShowData(c, datas, f, r);
          },
          onAfterCancel: function () {
            f.remove();
            r && r.remove();
            window.FX.STATIC.APPID = d.appId;
            window.FX.STATIC.ENTRYID = d.entryId
          }
        }))
      }, function () {
        r && r.remove();
        f.remove();
        t11 && t11.remove();
        return !1;
      }, function () {
        r && r.remove();
        t11 && t11.remove();
      })
    }
  }

  create = (res, menu, cb) => {

    let that = this;
    that.popupFormPath = that.popupFormPath || [];
    let _opt = this.props;
    let d1 = {
      formId: _opt.forms[0],
      appId: _opt.appId,
      entryId: _opt.entryId,
      authGroupId: _opt.origin ? null : _opt.authGroupId,
      extDashData: _opt.extDashData,
      popupFormPath: _opt.extDashData ? null : !_opt.origin ? undefined : that.popupFormPath.concat({
        appId: _opt.appId,
        entryId: _opt.entryId,
        formId: _opt.forms[0],
        widgetId: _opt.widgetId,
        // menuId: "create",
        // menuType: 'menu',
        menuId: menu.menuId,
        menuType: menu.menuType || "datamenu"

      }),
    };
    d1 = BsyUtils.checkRefApp(d1);
    let formConfig = {};
    if (res) {
      let that = this;
      that.isSubmitData = false
      const h = res ? res.data.entry : {};

      window.FX.STATIC.appId = h.appId;
      window.FX.STATIC.entryId = h.entryId;
      window.FX.STATIC.INNERLINK = h._id;

      if (!BsyUtils.isObjectEmpty(h.href)) {
        window.FX.STATIC.FORMHREF = h.href;
      }
      else {
        window.FX.STATIC.FORMHREF = null
      }

      formConfig = {
        ...h,
        appId: h.appId,
        entryId: h.entryId,
      }
      formConfig.content.width = '80%';
      formConfig.content.name = h.name;
      formConfig.content.designDataId = res.data ? res.data.dataId : '';
      //designDataId: g ? g.dataId : '',
    }
    that.isSubmitData = false;
    let layerRef = null;
    BsyMaskLayer({
      customCls: 'fadein-right',
      onMaskClick: (event) => {
        // if (event.target.classList.contains("fadein-right")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return <BsyFormPane
          hasHeader={true}
          width={'80%'}
          {...d1}
          formConfig={formConfig}
          mode={"new"}
          ignoreAuth={_opt.ignoreAuth}
          ignoreOptAuth={_opt.ignoreOptAuth}
          ignoreValidate={_opt.ignoreValidate}
          onClose={(status, data, autoClose) => {
            if (status) {
              if(!cb)
                that.reload({})
              that.isSubmitData = true;
            };
        
            cb && cb();
            layerRef && layerRef.close();
          }}
        />
      }
    })

  }
  creatForm = (res, isreload, cb, opt) => {
    let that = this;
    that.isSubmitData = false
    const h = res ? res.data.entry : {};

    window.FX.STATIC.appId = h.appId;
    window.FX.STATIC.entryId = h.entryId;
    window.FX.STATIC.INNERLINK = h._id;

    if (!BsyUtils.isObjectEmpty(h.href)) {
      window.FX.STATIC.FORMHREF = h.href;
    }
    else {
      window.FX.STATIC.FORMHREF = null
    }

    let formConfig = {
      ...h,
      appId: h.appId,
      entryId: h.entryId,
    }
    formConfig.content.width = 1080;
    formConfig.content.name = h.name;

    let layerRef = null;
    BsyMaskLayer({
      customCls: 'fadein-right',
      onMaskClick: (event) => {
        // if (event.target.classList.contains("fadein-right")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return <BsyFormPane
          hasHeader={true}
          formConfig={formConfig}
          mode={"new"}
          onClose={(status, data, autoClose) => {
            that.isSubmitData = status;

            if (status && isreload) {

              that.reload({})
            }
            layerRef && layerRef.close();
          }}
        />
      }
    })
  }

  BBY_reportCreatForm = (g, isreload, eventType, cb, opt) => {
    let that = this;
    that.isSubmitData = false
    eventType = eventType || "popupform";
    let n = this.props
      , e = this,
      f = window.$('<div class="x-window-mask modal light"/>').css({
        "z-index": window.FX.STATIC.zIndex++
      }).appendTo("body");
    window.FX.STATIC.IS_EVENT = g.entry.isEvent === true;
    let hasFooter = true;
    if (g.entry.content.isSubmit !== 'no')
      hasFooter = true;
    else
      hasFooter = false;

    window.FX.STATIC.APPID = g.entry.appId;
    window.FX.STATIC.ENTRYID = g.entry.entryId;

    let isref = false;
    let _options = this.props;
    let dd = BsyUtils.checkRefApp({
      appId: _options.appId,
      formId: _options.forms[0],
      entryId: _options.entryId,
    })
    let formview = new window.FX.Form(window.$.extend(g.entry.content, {
      renderEl: window.$("<div class='x-shadow-content'/>").appendTo(f),
      appId: g.entry.appId,
      entryId: g.entry.entryId,
      enableRowEdit: g.entry.enableRowEdit,
      hasFlow: !g.entry.hasCoop && g.entry.hasFlow,
      designDataId: g ? g.dataId : '',
      hasFlowPrint: g.entry.hasFlowPrint,
      flows: g.entry.flow,
      is_dock_form: g.is_dock_form,
      multiTabs: g.entry.formTabs,
      formTabsStyle: g.entry.formTabsStyle || {},
      isEvent: g.entry.isEvent,
      height: "100%",
      width: 1080,
      submitText: React.language("submit"),
      eventType: eventType,
      hasFooter: hasFooter,
      printText: g.entry.hasFlowPrint ? g.entry.flow.print_text : null,
      // buttonPosition: "middle",
      customCls: "more-btn fui_platform",
      submitUrl: "/data/create",
      title: g.entry.name,
      popupFormPath: e.popupFormPath.concat({
        appId: e.props.appId,
        entryId: e.props.entryId,
        formId: e.props.forms[0],
        widgetId: e.props.widgetId,
        menuId: opt.menuId,
        menuType: opt.menuType || 'datamenu',
      }),
      onSuccess: function (a, flowAction, needPrint) {
        isref = true;
        if (a.error_code) {
          let title = React.language("form.submit.fail.charger");
          let msg = React.language("form.submit.fail.charger.desc");
          if (a.error_code == window.FX.CONST.FLOW_FAIL_CODE.FORWARD_COND) {
            title = React.language("form.submit.fail.cond");
            msg = a.error_info //;
          }
          window.FX.Msg.alert({
            title: title,
            msg: msg,
            type: "warning",
            text4Cancel: null,
            text4Ok: React.language("iSee")
          });
          return;
        }
        that.isSubmitData = true
        formview.element.find('.widget-wrapper').empty();
        formview.element.find('.footer').remove();
        if (needPrint) {
          window.FX.Utils._showFormPrint(a.data)
          window.FX.Utils.showSuccessInfo(formview.element.find('.widget-wrapper'), a, function () {
            f.remove();
            e.BBY_reportCreatForm(g, isreload, eventType, cb, opt)
          });
        }
        else {

          if (a.submitPrompt.popupAutoClose) {
            window.FX.STATIC.APPID = n.appId;
            window.FX.STATIC.ENTRYID = n.entryId
            f.remove();
            if (isreload) {
              that.reload({})
            }
            cb && cb();
            return;
          }
          window.FX.Utils.showSuccessInfo(formview.element.find('.widget-wrapper'), a, function () {
            f.remove();
            e.BBY_reportCreatForm(g, isreload, eventType, cb, opt)
          });

        }

        // needPrint && BsyUtils._showFormPrint(a.data)
      },
      onError: function (a) {
        formview.element.find('.widget-wrapper').empty();
        formview.element.find('.footer').remove();
        window.FX.Utils.showErrorInfo(formview.element.find('.widget-wrapper'), a, function () {
          f.remove();
          e.BBY_reportCreatForm(g, isreload, eventType, cb, opt)
        })
      },
      onAfterCancel: function () {
        f.remove();
        if (eventType == 'new') {
          that.loadWidget()
        } else if (cb) {
          cb()
        }
        window.FX.STATIC.APPID = n.appId;
        window.FX.STATIC.ENTRYID = n.entryId;
      }
    }))
  }

  _isFieldsValid = () => {
    let t = this.props,
      e = !0;
    return e &= !BsyUtils.isEmpty(t.forms),
      e &= this._ganttCheckField(),
      BsyUtils.applyFunc(this, t.onCheckValid, [], !1),
      e
  }
  _ganttCheckField = () => {
    let t = this.props;
    let subofrm = undefined;
    //「开始时间」、「结束时间」、「进度」以及「维度」中子表单字段必须同属于一个子表单
    if (t.ganttFields) {
      if (t.ganttFields.start) {
        if (t.ganttFields.start.subform) {
          subofrm = t.ganttFields.start.subform;
        }
      } else {
        return false;
      }
      if (t.ganttFields.end) {
        if (t.ganttFields.end.subform != subofrm) {
          return false;
        }
      } else {
        return false;
      }
    }
    if (t.xFields == 0)
      return false;
    let hasSubform = true;
    BsyUtils.forEach(t.xFields, function (a1, b1) {
      if (b1.subform != subofrm) {
        hasSubform = false;
        return !1;
      }
    })
    if (!hasSubform) {
      return false;
    }
    return true;
  }
  /**
   * 前端对数据进行排序合并操作 从左到右为优化级重新构建数据
   * @param {*} data
   * @param {*} xFields 要对比的字符
   * @returns
   */
  _sortData = (data, xFields) => {
    let that = this;
    if (!data || data.length == 0)
      return [];
    let tmpdata = [...data];
    let keys = [];
    BsyUtils.forEach(xFields, function (a1, b1) {
      keys.push(b1.field)
    })
    //先把数组构建成json
    function groupBy(array, groupkeys) {
      if (groupkeys.length == 0)
        return array;
      if (array.length < 2)
        return array;
      let groupkey = groupkeys[0];
      groupkeys.splice(0, 1)

      let groups = {};
      //用于排序使用
      let groupkeymaps = {};
      let i = 0;
      array.forEach(function (o) {
        let group = 'tag_' + i + '_' + o[groupkey];
        if (!groupkeymaps[o[groupkey]]) {
          groupkeymaps[o[groupkey]] = group;
          groups[group] = [];
        } else {
          group = groupkeymaps[o[groupkey]];
        }

        // groups[group] = groups[group] || [];
        groups[group].push(o);
        i++;
      });
      for (let key in groups) {
        // if(key == 'JH-2021070003')
        //     debugger
        groups[key] = groupBy(groups[key], JSON.parse(JSON.stringify(groupkeys)));
      }
      return groups
    }
    //把json数据 还原成array
    function getGroupArray(json) {
      let result = [];
      if (Array.isArray(json)) {
        let len = json.length;
        if (len == 1) {

          result.push(json[0])
        } else {

          //多条数据进行合并处理
          let std = { ...json[0] };
          std.datas = []
          for (let key1 = 1; key1 < len; key1++) {
            let s = json[key1];
            std.datas.push(s)
          }
          result.push(std)
        }
      } else {
        for (let key in json) {
          if (Array.isArray(json[key])) {
            let len = json[key].length;
            if (len == 1) {
              result.push(json[key][0])
            } else {
              //多条数据进行合并处理
              let std = { ...json[key][0] };
              std.datas = []
              for (let key1 = 1; key1 < len; key1++) {
                let s = json[key][key1];
                std.datas.push(s)
              }
              result.push(std)
            }
          } else {
            result = result.concat(getGroupArray(json[key]))
          }
        }
      }

      return result;
    }
    let ret = groupBy(tmpdata, keys)
    return data = getGroupArray(ret);
  }
  _timesSort = (task) => {

    let d = { ...task };
    // return d;
    if (!d.hasOwnProperty('datas'))
      return d;

    let dd = [...d.datas];

    dd.push(d);

    for (let i = 0; i < dd.length - 1; i++) {
      //第i趟比较
      for (let j = 0; j < dd.length - i - 1; j++) {
        //开始进行比较，如果arr[j]比arr[j+1]的值大，那就交换位置
        if (dd[j].start > dd[j + 1].start) {
          let temp = dd[j];
          dd[j] = dd[j + 1];
          dd[j + 1] = temp;
        }
      }
    }
    let j = { ...dd[0] }
    dd.splice(0, 1);
    j.datas = dd;
    // console.log(j)
    return j;
  }


  mouseFouse = () => {
    const { classUUID } = this.state;
    let that = this;
    setTimeout(function () {
      let d = $Bsy('#' + classUUID);
      d.find('.bar-wrapper,.bar-label').hover((e) => {

        let id = e.currentTarget.getAttribute('data-id');
        d.find('.bar-wrapper[data-id="' + id + '"] .bar,.bar-wrapper[data-id="' + id + '"] .bar-progress').css({
          filter: "drop-shadow(0px 0px 1px " + that.taskMap[id].color + ")",
        })

        d.find('.bar-wrapper').addClass("disable");
        d.find('.bar-label').addClass("disable");
        d.find('.arrow path').addClass("disable");

        d.find('.bar-wrapper[data-id="' + id + '"]').removeClass("disable");
        d.find('.bar-label[data-id="' + id + '"]').removeClass("disable");
        d.find('.arrow path[data-from="' + id + '"]').removeClass("disable");
        d.find('.arrow path[data-to="' + id + '"]').removeClass("disable");

        //让相关联的线条高亮
        d.find('.arrow path[data-from="' + id + '"]').addClass("light-color");
        d.find('.arrow path[data-to="' + id + '"]').addClass("light-color");

      }, (e) => {
        let id = e.currentTarget.getAttribute('data-id');
        d.find('.bar-wrapper').removeClass("disable");
        d.find('.bar-label').removeClass("disable");
        d.find('.arrow path').removeClass("disable");
        d.find('.arrow path').removeClass("light-color");
        d.find('.bar-wrapper[data-id="' + id + '"] .bar,.bar-wrapper[data-id="' + id + '"] .bar-progress').css({
          filter: "unset",
        })
      })
    }, 500)
  }

  _createDataCell = (data) => {
    let opt = this.props;
    let that = this;
    let xFields = [...opt.xFields];
    if (opt.chart_label.enable && opt.chart_label.field) {
      xFields.push(opt.chart_label.field)
    }
    BsyUtils.forEach(xFields, function (index, field) {
      if (!data.hasOwnProperty(field.tag)) {
        data[field.tag] = '';
        return;
      }
      switch (field.type) {
        case "checkboxgroup":
        case "combocheck":
        case "array":
        case "radiogroup":
        case "combo":
        case "string":
        case "text":
        case "id":
        case "did":
        case "dept":
        case "usergroup":
        case "deptgroup":

          data[field.tag] = BsyUtils.escapeHtmlSpecialChar(data[field.tag]);
          break;
        case "flowState": {
          switch (parseInt(data[field.tag])) {
            case BsyConfig().CONST.WORKFLOW.FLOWSTATE.INPROCESS:
              data[field.tag] = React.language("flow.state.inProcess")
              break;
            case BsyConfig().CONST.WORKFLOW.FLOWSTATE.COMPLETE:
              data[field.tag] = React.language("flow.node.end")
              break;
            case BsyConfig().CONST.WORKFLOW.FLOWSTATE.CLOSE:
              data[field.tag] = React.language("flow.state.closed")
              break;
            default:
              data[field.tag] = '';
          }
          break;
        }
        case "user":
          if (data[field.tag].hasOwnProperty('nickname')) {
            data[field.tag].src = data[field.tag].avatar;
            data[field.tag].nickname = BsyUtils.escapeHtmlSpecialChar(data[field.tag].nickname);
          }

          break
        case "address":
        case "location":
          let l = [];
          let e = data[field.tag];
          e.province && l.push(e.province);
          e.city && e.province !== e.city && l.push(e.city)
          e.district && l.push(e.district)
          e.detail && l.push(e.detail)
          data[field.tag] = BsyUtils.address2Str(e, e.format);
          data[field.tag] = BsyUtils.escapeHtmlSpecialChar(data[field.tag]);
          break;
        case "datetime":
          if (data[field.tag]) {
            data[field.tag] = BsyUtils.date2Str(dayjsUtils.timeToTZ(data[field.tag]), field.format || 'yyyy-MM-dd');
            data[field.tag] = BsyUtils.escapeHtmlSpecialChar(data[field.tag]);
          }
          break;
        case "formula":
        case "number":
          if (data[field.tag]) {

            let res = BsyUtils.numberFormatValue(data[field.tag], field);
            const afterSuffixVal = getAfterSuffix(field.afterSuffix)
            if (afterSuffixVal && res.text && !res.text.includes("%")) {
              res.text = res.text + " " +afterSuffixVal;
            }
            data[field.tag] = res.text;
          }
          break;
        case "linkdata":
          let e1 = data[field.tag];
          let d = e1 && e1.key;
          if (BsyUtils.isNull(d)) {
            data[field.tag] = ''
            break;
          }
          "datetime" === field.linkType ? data[field.tag] = BsyUtils.date2Str(dayjsUtils.timeToTZ(d), "yyyy-MM-dd") : data[field.tag] = d;
          data[field.tag] = BsyUtils.escapeHtmlSpecialChar(data[field.tag]);
          break;
        default:
          data[field.tag] = BsyUtils.escapeHtmlSpecialChar(data[field.tag]);
          break;
      }

    })
    return data
  }
  //构建数据
  _initData = (d) => {

    let opt = this.props;
    let that = this;


    // opt.xFields = [{ "name": "_widget_1681181128283", "type": "text", "title": "汇报人1", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364266320" }, { "name": "_widget_1681181128284", "type": "combo", "title": "选择项目", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364266525" }, { "name": "_widget_1681181128285", "type": "combo", "title": "选择模块", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364444095" }];
    // opt.ganttFields = { "start": { "name": "_widget_1681181128287", "text": "工作开始时间", "type": "datetime", "format": "yyyy-MM-dd", "title": "工作开始时间", "form": "5fef3d77c96ac7eab699fa95", "icon": "icon-widget-datetime", "group": "dimension,quota,$dimension,filter,ganttshowfield,t-dimension", "formula": "", "tag": "f_1681364266351", "date_precision": "day" }, "end": { "name": "_widget_1681181128292", "text": "工作结束时间", "type": "datetime", "format": "yyyy-MM-dd", "title": "工作结束时间", "form": "5fef3d77c96ac7eab699fa95", "icon": "icon-widget-datetime", "group": "dimension,quota,$dimension,filter,ganttshowfield,t-dimension", "formula": "", "tag": "f_1681364266382", "date_precision": "day" }, "progress": { "name": "_widget_1681181128289", "text": "进度", "type": "number", "title": "进度", "form": "5fef3d77c96ac7eab699fa95", "icon": "icon-widget-number", "group": "quota,$dimension,filter,ganttshowfield,n-dimension", "formula": "", "tag": "f_1681364266764" } };
    // opt.fields = [{ "name": "_widget_1681181128283", "type": "text", "title": "汇报人1", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553527" }, { "name": "_widget_1681181128284", "type": "combo", "title": "选择项目", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553478" }, { "name": "_widget_1681181128285", "type": "combo", "title": "选择模块", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553576" }, { "name": "_widget_1681181128305", "type": "text", "title": "工作内容", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553625" }, { "name": "_widget_1681181128306", "type": "number", "title": "工作时长（小时）", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553772" }, { "name": "_widget_1681181128294", "type": "number", "regex": "^[-]?[\\\\d]{0,}[\\\\.]?[\\\\d]{0,}$", "notround": false, "displayMode": "number", "thousandsSeparator": false, "title": "今日工作时长", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553674" }];

    // opt.chart_label = {
    //   "enable": true,
    //   "field": {
    //     "form": "5fef3d77c96ac7eab699fa95",
    //     "value": "f_1681182092734",
    //     "text": "工作时长（小时）",
    //     "name": "_widget_1681181128306",
    //     "type": "number",
    //     "tag": "f_1681182092734"
    //   }
    // }

    // BsyUtils.applyFunc(that, opt.onLoadSuccess, [{}], !1)

    this.hasSubform = !1;
    this.columns = [];
    this.tasks = [];
    BsyUtils.forEach(opt.xFields, function (index, field) {
      that.columns.push({
        label: field.title || field.text || "",
        field: field.tag || field.name,
      })
    })
    if (opt.xFields[0].hasOwnProperty('subform')) {
      this.hasSubform = !0;
    }
    // console.log(d.data_list)

    let data_list = this._sortData(d.data_list, that.columns);
    this.legendDatas = [];
    // console.log(data_list)
    let legendField = that.columns[that.columns.length - 1].field

    BsyUtils.forEach(data_list, function (index, data) {
      data = that._createDataCell(data);
      let legend = data[legendField];
      let subformDataId = "";
      if (that.hasSubform)
        subformDataId = window.FX.STATIC.IDBase++;
      that.legendDatas.push({
        data: legend,
        _id: data._id + subformDataId,
        color: '#a3a3ff',
      });
      let progress = undefined;

      if (opt.ganttFields.progress) {
        progress = data[opt.ganttFields.progress.tag || opt.ganttFields.progress.name];
        if (progress > 1) {
          progress = 1;
        }
        if (progress < 0) {
          progress = 0;
        }
        progress = (progress * 100)
      }


      let task = {
        id: "task_" + data._id + subformDataId,
        start: BsyUtils.date2Str(dayjsUtils.timeToTZ(data[opt.ganttFields.start.tag || opt.ganttFields.start.name]), "yyyy-MM-dd HH:mm:ss"),
        end: BsyUtils.date2Str(dayjsUtils.timeToTZ(data[opt.ganttFields.end.tag || opt.ganttFields.end.name]), "yyyy-MM-dd HH:mm:ss"),
        progress: progress,
        legend: legend
      }
      if (opt.taskIdField && opt.taskIdField.tag) {
        task.dependencieId = data[opt.taskIdField.tag || opt.taskIdField.name]
      }
      if (opt.taskDependenciesField && opt.taskDependenciesField.tag) {
        task.dependencies = data[opt.taskDependenciesField.tag || opt.taskDependenciesField.name]
      }
      task = { ...task, ...data };
      task.name = "";
      if (opt.chart_label.enable && opt.chart_label.field) {
        if (data[opt.chart_label.field.tag || opt.chart_label.field.name]) {
          task.name = data[opt.chart_label.field.tag || opt.chart_label.field.name];
        }
      }

      if (task.hasOwnProperty('datas')) {
        //BsyUtils.date2Str(datas[opt.ganttFields.start.tag || opt.ganttFields.start.name], "yyyy-MM-dd HH:mm:ss")
        BsyUtils.forEach(task.datas, function (datasindex, datas) {

          task.datas[datasindex] = that._createDataCell(task.datas[datasindex]);

          task.datas[datasindex].id = "task_" + datas._id + subformDataId;
          task.datas[datasindex].start = BsyUtils.date2Str(dayjsUtils.timeToTZ(datas[opt.ganttFields.start.tag || opt.ganttFields.start.name]), "yyyy-MM-dd HH:mm:ss");
          task.datas[datasindex].end = BsyUtils.date2Str(dayjsUtils.timeToTZ(datas[opt.ganttFields.end.tag || opt.ganttFields.end.name]), "yyyy-MM-dd HH:mm:ss");
          task.datas[datasindex].legend = datas[legendField];

          let progress1 = undefined;
          if (opt.ganttFields.progress) {
            progress1 = datas[opt.ganttFields.progress.tag || opt.ganttFields.progress.name];
            if (progress1 > 1) {
              progress1 = 1;
            }
            if (progress1 < 0) {
              progress1 = 0;
            }
            progress1 = (progress1 * 100);
          }

          task.datas[datasindex].progress = progress1
          let name = "";
          if (opt.chart_label.enable && opt.chart_label.field) {
            if (datas[opt.chart_label.field.tag || opt.chart_label.field.name]) {
              name = datas[opt.chart_label.field.tag || opt.chart_label.field.name];
            }
          }
          task.datas[datasindex].name = name;
          if (opt.taskIdField && opt.taskIdField.tag) {
            task.datas[datasindex].dependencieId = datas[opt.taskIdField.tag || opt.taskIdField.name]
          }
          if (opt.taskDependenciesField && opt.taskDependenciesField.tag) {
            task.datas[datasindex].dependencies = datas[opt.taskDependenciesField.tag || opt.taskDependenciesField.name]
          }
        })
      }

      // let name =  data[opt.ganttFields.end.tag || opt.ganttFields.end.name]
      task = that._timesSort(task);
      that.tasks.push(task)
    })

    this.datamaps = {};
    this.legend_datas = [];
    //先过滤重复的
    BsyUtils.forEach(that.legendDatas, function (a1, b1) {
      if (!that.datamaps.hasOwnProperty(b1.data)) {
        that.datamaps[b1.data] = [b1._id];
        that.legend_datas.push(b1);
      } else {
        that.datamaps[b1.data].push(b1._id)
      }
    })

  }

  _getFieldColor = (t, e, i) => {
    t || (t = i[e % i.length])
    return t
  }

  getFilterData = (t) => {
    let e = this.props
      , i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1)
      , a = [];
    let i = i1.filter;
    this.filterMap = i1.filterMap;
    i && (a = a.concat(i))
    BsyUtils.isObjectEmpty(t) || (a = a.concat(t))
    e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond))
    return BsyUtils.isObjectEmpty(a) ? {} : {
      cond: a,
      rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND
    }
  }

  _setFilterParam = (t) => {
    BsyUtils.isNull(t) || (this.filterParam = t)
  }

  loadData = (n, d) => {
    const { url, limit, skip, fields, filter, sort, appId, entryId, widgetId, isLoading } = this.state;

    let autoload = this.props.autoLoad;
    if (this.props.onIsAutoLoad)
      autoload = this.props.onIsAutoLoad()

    if (!autoload) {
      this.setState({
        dataEmpty: true,
      })
      return
    }

    if (isLoading)
      return;
    this.isDashFull = n;
    this.setState({
      isLoading: true,
    }, () => {
      React.axios(url, {
        limit: limit,
        skip: skip * limit,
        fields: fields,
        filter: this.getFilterData(this.filterParam),
        sort: sort,
        appId: appId,
        entryId: entryId,
        widgetId: widgetId,
        hasCount: false,
        isCountOnly: false

      }, { dashMode: n }).then(res => {

        if (res.data.hasOwnProperty('code') && res.data.code === 3000) {
          //onConfigError
          if (this.props.onConfigError) {
            this.props.onConfigError(res.data)
          }
          if (this.props.onLoadFail) {
            this.props.onLoadFail(n, d)
          }
          return;
        }
        // res.data = { "header": [{ "name": "_widget_1681181128283", "type": "text", "title": "汇报人1", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553527" }, { "name": "_widget_1681181128284", "type": "combo", "title": "选择项目", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553478" }, { "name": "_widget_1681181128285", "type": "combo", "title": "选择模块", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553576" }, { "name": "_widget_1681181128305", "type": "text", "title": "工作内容", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553625" }, { "name": "_widget_1681181128306", "type": "number", "title": "工作时长（小时）", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553772" }, { "name": "_widget_1681181128294", "type": "number", "regex": "^[-]?[\\d]{0,}[\\.]?[\\d]{0,}$", "notround": false, "displayMode": "number", "thousandsSeparator": false, "title": "今日工作时长", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681373553674" }, { "name": "_widget_1681181128283", "type": "text", "title": "汇报人1", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364266320" }, { "name": "_widget_1681181128284", "type": "combo", "title": "选择项目", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364266525" }, { "name": "_widget_1681181128285", "type": "combo", "title": "选择模块", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364444095" }, { "name": "_widget_1681181128287", "type": "datetime", "format": "yyyy-MM-dd", "title": "工作开始时间", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364266351", "date_precision": "day" }, { "name": "_widget_1681181128292", "type": "datetime", "format": "yyyy-MM-dd", "title": "工作结束时间", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364266382", "date_precision": "day" }, { "name": "_widget_1681181128289", "type": "number", "title": "进度", "form": "5fef3d77c96ac7eab699fa95", "tag": "f_1681364266764" }, { "form": "5fef3d77c96ac7eab699fa95", "value": "f_1681182092734", "name": "_widget_1681181128306", "type": "number", "tag": "f_1681182092734" }], "data_list": [{ "f_1681373553527": "马昊", "f_1681373553478": "日常工作", "f_1681373553576": "功能测试", "f_1681373553625": "归纳总结学科测试知识点", "f_1681373553772": "3.5", "f_1681373553674": "8", "f_1681364266320": "马昊", "f_1681364266525": "日常工作", "f_1681364444095": "功能测试", "f_1681364266351": "2023-04-12T16:00:00Z", "f_1681364266382": "2023-04-13T15:59:59Z", "f_1681364266764": "0.44", "f_1681182092734": "3.5", "_id": "14", "dataPerms": { "update": false, "delete": false }, "optAuth": { "_widget_1681181128283": { "visible": true, "enable": false }, "_widget_1681181128284": { "visible": true, "enable": false }, "_widget_1681181128285": { "visible": true, "enable": false }, "_widget_1681181128305": { "visible": true, "enable": false }, "_widget_1681181128306": { "visible": true, "enable": false }, "_widget_1681181128287": { "visible": true, "enable": false }, "_widget_1681181128292": { "visible": true, "enable": false }, "_widget_1681181128294": { "visible": true, "enable": false }, "_widget_1681181128289": { "visible": true, "enable": false } } }, { "f_1681373553527": "马昊", "f_1681373553478": "日常工作", "f_1681373553576": "写代码", "f_1681373553625": "编写知识点chatGPT测试代码", "f_1681373553772": "2.5", "f_1681373553674": "8", "f_1681364266320": "马昊", "f_1681364266525": "日常工作", "f_1681364444095": "写代码", "f_1681364266351": "2023-04-12T16:00:00Z", "f_1681364266382": "2023-04-13T15:59:59Z", "f_1681364266764": "0.31", "f_1681182092734": "2.5", "_id": "14", "dataPerms": { "update": false, "delete": false }, "optAuth": { "_widget_1681181128283": { "visible": true, "enable": false }, "_widget_1681181128284": { "visible": true, "enable": false }, "_widget_1681181128285": { "visible": true, "enable": false }, "_widget_1681181128305": { "visible": true, "enable": false }, "_widget_1681181128306": { "visible": true, "enable": false }, "_widget_1681181128287": { "visible": true, "enable": false }, "_widget_1681181128292": { "visible": true, "enable": false }, "_widget_1681181128294": { "visible": true, "enable": false }, "_widget_1681181128289": { "visible": true, "enable": false } } }, { "f_1681373553527": "马昊", "f_1681373553478": "日常工作", "f_1681373553576": "查资料", "f_1681373553625": "学习海防文档", "f_1681373553772": "2", "f_1681373553674": "8", "f_1681364266320": "马昊", "f_1681364266525": "日常工作", "f_1681364444095": "查资料", "f_1681364266351": "2023-04-12T16:00:00Z", "f_1681364266382": "2023-04-13T15:59:59Z", "f_1681364266764": "0.25", "f_1681182092734": "2", "_id": "14", "dataPerms": { "update": false, "delete": false }, "optAuth": { "_widget_1681181128283": { "visible": true, "enable": false }, "_widget_1681181128284": { "visible": true, "enable": false }, "_widget_1681181128285": { "visible": true, "enable": false }, "_widget_1681181128305": { "visible": true, "enable": false }, "_widget_1681181128306": { "visible": true, "enable": false }, "_widget_1681181128287": { "visible": true, "enable": false }, "_widget_1681181128292": { "visible": true, "enable": false }, "_widget_1681181128294": { "visible": true, "enable": false }, "_widget_1681181128289": { "visible": true, "enable": false } } }, { "f_1681373553527": "马昊", "f_1681373553478": "日常工作", "f_1681373553576": "功能测试", "f_1681373553625": "测试学科知识点和答案", "f_1681373553772": "4.5", "f_1681373553674": "8", "f_1681364266320": "马昊", "f_1681364266525": "日常工作", "f_1681364444095": "功能测试", "f_1681364266351": "2023-04-13T16:00:00Z", "f_1681364266382": "2023-04-14T15:59:59Z", "f_1681364266764": "0.56", "f_1681182092734": "4.5", "_id": "103", "dataPerms": { "update": false, "delete": false }, "optAuth": { "_widget_1681181128283": { "visible": true, "enable": false }, "_widget_1681181128284": { "visible": true, "enable": false }, "_widget_1681181128285": { "visible": true, "enable": false }, "_widget_1681181128305": { "visible": true, "enable": false }, "_widget_1681181128306": { "visible": true, "enable": false }, "_widget_1681181128287": { "visible": true, "enable": false }, "_widget_1681181128292": { "visible": true, "enable": false }, "_widget_1681181128294": { "visible": true, "enable": false }, "_widget_1681181128289": { "visible": true, "enable": false } } }, { "f_1681373553527": "马昊", "f_1681373553478": "日常工作", "f_1681373553576": "查资料", "f_1681373553625": "学习海防项目", "f_1681373553772": "3.5", "f_1681373553674": "8", "f_1681364266320": "马昊", "f_1681364266525": "日常工作", "f_1681364444095": "查资料", "f_1681364266351": "2023-04-13T16:00:00Z", "f_1681364266382": "2023-04-14T15:59:59Z", "f_1681364266764": "0.44", "f_1681182092734": "3.5", "_id": "103", "dataPerms": { "update": false, "delete": false }, "optAuth": { "_widget_1681181128283": { "visible": true, "enable": false }, "_widget_1681181128284": { "visible": true, "enable": false }, "_widget_1681181128285": { "visible": true, "enable": false }, "_widget_1681181128305": { "visible": true, "enable": false }, "_widget_1681181128306": { "visible": true, "enable": false }, "_widget_1681181128287": { "visible": true, "enable": false }, "_widget_1681181128292": { "visible": true, "enable": false }, "_widget_1681181128294": { "visible": true, "enable": false }, "_widget_1681181128289": { "visible": true, "enable": false } } }], "reftype": "etl_table", "data_update": { "has_delay_task": false, "last_run_time": "2023-04-15T11:05:00Z", "last_status": "success", "time": [], "mode": "time" } };

        this.reftype = res.data.reftype;
        BsyUtils.showAjaxTip(res.data, () => {
          //dataEmpty
          if (res.data.data_list.length === 0) {
            this.setState({
              dataEmpty: true,
              isLoading: false,
            }, () => {

              if (this.props.onLoadSuccess) {
                this.props.onLoadSuccess(res.data, n, d)
              }
            })
            return
          }

          if (res.data.reftype == 'etl_table') {
            BsyUtils.forEach(res.data.data_list, function (a1, b1) {
              res.data.data_list[a1]._id = a1
            })
          }

          this._getStyles();
          this._initData(res.data)
          this._getColors()
          this.setState({
            dataEmpty: false,
            isLoading: false,
            zoomLevel: this.zoomLevel,
            modeText: BsyUtils.getGanttZoomlevelName(this.zoomLevel)
          }, () => {
            this.renderGantt();
            if (this.props.onLoadSuccess) {
              this.props.onLoadSuccess(res.data, n, d)
            }
          })
        }, () => {
          if (this.props.onLoadFail) {
            this.props.onLoadFail(n, d)
          }
        })

      }).catch(res => {
        if (this.props.onLoadFail) {
          this.props.onLoadFail(n, d)
        }
        console.error(res);
        this.setState({
          isLoading: false,
        })
      })
    })
  }

  _getStyles = () => {
    const { widgetId } = this.state;
    let style = BsyUtils.applyFunc(this, this.props.onGetStyles, [widgetId], !1)
    this.palette = this.props.palette;
    if (style) {
      if (style.theme && style.theme.palette) {
        if (this.palette == "default" || !this.palette) {
          this.palette = style.theme.palette;
        }
      }
    }
  }

  reload = (options) => {
    const { zoomLevel } = this.state;
    this.setState({
      ...this.state,
      ...options,
      zoomLevel
    }, () => {
      this.loadWidget()
    })
  }



  doResize = () => {
    // this.ref.current.innerHTML = '';

    if (!this.state.dataEmpty) {
      this.renderGantt();
    }
  }

  renderGantt = () => {
    let that = this;
    let _opt = this.props;
    this.ref.current.innerHTML = '';
    this.gantt = new Gantt(this.ref.current, this.tasks, {
      language: "zh",
      popup_trigger: 'mousemove',
      columns: this.columns,
      elWidth: this.rootRef.current.clientWidth,//this.element.width(),
      step: 24,
      bar_height: 26,
      bar_corner_radius: 3,
      arrow_curve: 5,
      padding: 18,
      view_mode: BsyUtils.getGanttZoomlevel(this.zoomLevel) || "Week",
      onChangeResize: function (size) {
        that._updateInfoSize(size);
      },
      onGetResize: function (size) {
        return that._getInfoSizeMap() || 0;
      },
      on_click: function (task) {
        that.taskTip(task.id);
      },

      on_view_change: function (mode) {
        // $('#mode').text("当前模式：" + mode)
        // if(ganttel.find('.task-content-wrapper')[0].scrollLeft == 0)
        //     ganttel.find('.task-content-wrapper')[0].scrollLeft = 1
        // console.log('on_view_change:' + mode)
        that.mouseFouse();
      },
      on_pupup: function (task, columns, $bar) {
        // console.log(arguments)
        let cont = {};
        cont.starttime = React.language('dash.gantt.bar.start') + task.start
        cont.endtime = React.language('dash.gantt.bar.end') + task.end
        cont.progress = '';
        if (BsyUtils.isNumber(task.progress)) {
          if (task.progress > 100) {
            task.progress = 100
          }
          let r = BsyUtils.fixDecimalPrecision(task.progress / 100);
          r = BsyUtils.num2Str(r, _opt.ganttFields.progress.format || '0.%');

          cont.progress = React.language('dash.gantt.bar.progress') + r;
        }
        let s = [];
        cont.str = "";
        for (let c in columns) {
          if (task[columns[c].field]) {
            s.push(task[columns[c].field])
          }
        }
        if (s.length)
          cont.str = s.join(' / ');
        return cont;

      }
    });
  }



  _getColors = () => {
    let t = this.props,
      e = this,
      i = [],
      n = []
    let r = e.palette;
    r === 'default' && (r = 'preset_1')


    BsyUtils.forEach(BsyConfig().CONST.DASH_CHART_THEME, function (t, e) {
      if (e.value === r) {
        n = e.colors.slice(0)
        return !1
      }

    });
    this.taskMap = {};
    this.DEFAULT_COLORS = ["#1397DC", "#12C1EC", "#6FE498", "#F5D04F", "#FF9F7F", "#FB7293", "#DA99EC", "#8378EA"];
    n.length || (n = this.DEFAULT_COLORS)

    let o = {};
    BsyUtils.forEach(t.xFields[0].colors, function (t, e) {
      o[e.value] = e.color
    })
    // let series = this.getChartData().series;

    let field = t.xFields[t.xFields.length - 1].tag

    let legend_datas_map = {};
    BsyUtils.forEach(this.legend_datas, function (t, r) {
      legend_datas_map[r.data] = e._getFieldColor(o[r.data], t, n);
    })


    BsyUtils.forEach(this.tasks, function (t, r) {
      let val = r[field];
      // i.push(e._getFieldColor(o[r], t, n))
      e.tasks[t].color = legend_datas_map[r[field]] ? legend_datas_map[r[field]] : '';
      e.taskMap[r.id] = r;
      if (e.tasks[t].hasOwnProperty('datas')) {
        let ng = e.tasks[t].datas.length;
        for (let index = 0; index < ng; index++) {
          // e.tasks[t].datas[index].color = e.tasks[t].color;
          e.tasks[t].datas[index].color = legend_datas_map[r.datas[index][field]] ? legend_datas_map[r.datas[index][field]] : '';
          e.taskMap[e.tasks[t].datas[index].id] = e.tasks[t].datas[index];
        }
      }
      e.legendDatas[t].color = e.tasks[t].color;
    });

    return i
  }

  renderLegend = () => {
    const { classUUID } = this.state;
    let that = this;
    let legend_width_Max = 0;
    this.legend_datas.map((data, index) => {
      let width = BsyUtils.getTextWidth(data.data);
      legend_width_Max = legend_width_Max > width ? legend_width_Max : width;
    })
    let rows = 3;
    // if (this.rootRef.current) {
    //+ 40  边间距
    if (this.elWidth == 0) {
      if (this.rootRef.current)
        this.elWidth = this.rootRef.current.offsetWidth;
    }
    if (this.elWidth > 0) {
      let cols = Math.floor((this.elWidth - 40) / (legend_width_Max + 40))
      rows = Math.ceil(this.legend_datas.length / cols);
      if (rows > 3) {
        rows = 3;
      }
    }

    // }

    let onClick = (e, dv) => {
      let d = $Bsy('#' + classUUID);
      let data = window.FX.Utils.Base64Encode(dv.data)
      if (e.currentTarget.classList.contains('hide')) {
        e.currentTarget.classList.remove('hide')

        d.find('.bar-wrapper[data-legend="' + data + '"]').removeClass("hide");
        d.find('.bar-label[data-legend="' + data + '"]').removeClass("hide");
        d.find('.arrow path').removeClass("hide");
      } else {
        e.currentTarget.classList.add('hide')

        d.find('.bar-wrapper[data-legend="' + data + '"]').addClass("hide");
        d.find('.bar-label[data-legend="' + data + '"]').addClass("hide");
        BsyUtils.forEach(that.datamaps[dv.data], function (a1, b1) {
          d.find('.arrow path[data-from="task_' + b1 + '"]').addClass("hide");
          d.find('.arrow path[data-to="task_' + b1 + '"]').addClass("hide");
        })
      }
    }

    let onMouseEnter = (e, dv) => {
      let d = $Bsy('#' + classUUID);

      d.find('.gantt-legend-item').addClass("disable");
      d.find('.bar-wrapper').addClass("disable");
      d.find('.bar-label').addClass("disable");
      let data = window.FX.Utils.Base64Encode(dv.data)

      d.find('.bar-wrapper[data-legend="' + data + '"]').removeClass("disable");
      d.find('.bar-label[data-legend="' + data + '"]').removeClass("disable");
      d.find('.arrow path').addClass("disable");
      e.currentTarget.classList.remove('disable')

      // BsyUtils.forEach(that.datamaps[dv.data], function (a1, b1) {

      //   d.find('.arrow path[data-from="task_' + b1 + '"]').removeClass("disable").attr('data-to');
      //   d.find('.arrow path[data-to="task_' + b1 + '"]').removeClass("disable").attr('data-from');

      // })
    }

    let onMouseLeave = (e, dv) => {
      let d = $Bsy('#' + classUUID);
      d.find('.gantt-legend-item').removeClass("disable");
      d.find('.bar-wrapper').removeClass("disable");
      d.find('.bar-label').removeClass("disable");
      d.find('.arrow path').removeClass("disable");
    }

    return <div className={'gantt-legend row-' + rows} > {
      this.legend_datas.map((data, index) => {
        return <div key={data._id} className="gantt-legend-item"
          style={
            (this.props.legend.position === 'left' || this.props.legend.position === 'right') ? {} :
              {
                width: (legend_width_Max + 30) + 'px',
              }}
          onMouseEnter={e => { onMouseEnter(e, data) }}
          onMouseLeave={e => { onMouseLeave(e, data) }}
          onClick={e => { onClick(e, data) }}
        >
          <span className="color"
            style={{
              background: data.color || '#a3a3ff'
            }}

          ></span>
          <span className="text" >{data.data}</span>
        </div>
      })
    } </div>
  }

  BarOnSpotChange = (e) => {


    //   onSpotChange: BsyUtils.Debounce(function (e) {
    let val = Math.floor(e)
    if (val != this.zoomLevel) {
      this.zoomLevel = val;
      this.gantt.change_view_mode(BsyUtils.getGanttZoomlevel(this.zoomLevel))
      this.setState({
        zoomLevel: this.zoomLevel,
        modeText: BsyUtils.getGanttZoomlevelName(this.zoomLevel)
      })
      // setModeText();
    }


    // }, 5)

    // console.log('BarOnSpotChange', val)
  }

  zoomAdd = () => {

    const { level, zoomLevel } = this.state;
    if (zoomLevel >= level)
      return;
    let d = zoomLevel + 1;
    this.setState({
      zoomLevel: d,
      modeText: BsyUtils.getGanttZoomlevelName(d)
    }, () => {
      this.gantt.change_view_mode(BsyUtils.getGanttZoomlevel(d))
    })


  }

  zoomReduce = () => {
    const { zoomLevel } = this.state;
    if (zoomLevel == 0)
      return;

    let d = zoomLevel - 1;
    this.setState({
      zoomLevel: d,
      modeText: BsyUtils.getGanttZoomlevelName(d)
    }, () => {
      this.gantt.change_view_mode(BsyUtils.getGanttZoomlevel(d))
    })

  }

  showLoading = () => {
    const { isLoading } = this.state;
    if (!this.isDashFull) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={'skeletonspin'} /> : ''
    }
    if (!(this.props.autoRefresh && (this.props.autoRefresh && this.props.autoRefresh.enabled))) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={'skeletonspin'} /> : ''
    }
    return '';
  }

  render() {
    const { classUUID, zoomLevel, level, modeText, dataEmpty, isLoading } = this.state;

    return (<div className={'bsy-gantt ' + this.props.legend.position} id={classUUID}  >

      {
        (this.props.legend.enable && (this.props.legend.position === 'left' || this.props.legend.position === 'top')) ?
          this.renderLegend() : ''
      }
      <div className={'gantt-content'} ref={this.rootRef}
        style={{
          display: (dataEmpty || isLoading) ? 'none' : 'block'
        }}
      >
        <div className={'gantt-elemen'} ref={this.ref} >

        </div>
        <div className="gantt-zoom">
          <span className="gantt-mode">{modeText}</span>
          <span onClick={this.zoomReduce} ><i className="icon-narrow"></i></span>
          <BsyProgressBar
            width={'100%'}
            value={zoomLevel}
            valMin={0}
            valMax={level}
            showValue={!1}
            onSpotChange={this.BarOnSpotChange}
          />
          <span onClick={this.zoomAdd} ><i className="icon-enlargement" /></span>
        </div>
      </div>
      {
        (this.props.legend.enable && (this.props.legend.position === 'bottom' || this.props.legend.position === 'right')) ?
          this.renderLegend() : ''
      }
      {
        this.showLoading()
      }
      {
        dataEmpty ? <div className={'chart-data-empty'}><div><i className={BsyUtils._getWidgetTypeIcon(this.props.chartType)}></i><span>{React.language('widget.linkdata.empty')}</span></div></div> : ''
      }
    </div>
    );
  }

  BBY_doSort = () => {
    let t = this.props
      , e = this
      , i = []
      , n = [];
    i = BsyUtils.getDashSortFields(t.xFields)
    let r = new window.FX.ConfirmDialog({
      title: React.language("dash.sort.setting"),
      width: 600,
      text4Ok: React.language("sort"),
      hasSeparator: !0,
      onContentCreate: function (t) {
        e.dashChartSort = new window.FX.DashChartSortPane({
          renderEl: t,
          sorts: e.state.sort,
          fields: i,
          incompatibleTags: n,
          hideCustomSort: !0
        })
      },
      onOk: function () {
        let t = e.dashChartSort.getSorts();
        e.hasSort = !0
        e.setState({
          sort: t,
        }, () => {
          e.loadWidget();
        })
        //e.dashSort.reset(t);
        r.close()
      }
    });
    r.show()
  }
}
